import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api';

const card = { background: '#1e293b', borderRadius: 12, padding: 24, marginBottom: 24 };
const inputStyle = { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: '#e2e8f0', width: '100%' };
const btnStyle = { background: '#38bdf8', color: '#0f172a', border: 'none', borderRadius: 8, padding: '10px 24px', fontWeight: 700, cursor: 'pointer' };

export default function Trades({ embedded = false }) {
  const qc = useQueryClient();
  const [form, setForm] = useState({ symbol: '', type: 'buy', quantity: '', price: '' });

  const { data: trades = [] } = useQuery({
    queryKey: ['trades'],
    queryFn: () => api.get('/api/trades').then(r => r.data),
  });

  const mutation = useMutation({
    mutationFn: (data) => api.post('/api/trades', data).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['trades'] });
      setForm({ symbol: '', type: 'buy', quantity: '', price: '' });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({ ...form, quantity: Number(form.quantity), price: Number(form.price) });
  };

  return (
    <div>
      {!embedded && <h1 style={{ marginBottom: 24, fontSize: 24, fontWeight: 700 }}>Trades</h1>}

      <div style={card}>
        <h2 style={{ marginBottom: 16, fontSize: 16, color: '#94a3b8' }}>New Trade</h2>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
          <input style={inputStyle} placeholder="Symbol (ex: BTCUSDT)" value={form.symbol} onChange={e => setForm(f => ({ ...f, symbol: e.target.value }))} required />
          <select style={inputStyle} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}>
            <option value="buy">Buy</option>
            <option value="sell">Sell</option>
          </select>
          <input style={inputStyle} type="number" placeholder="Quantity" value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: e.target.value }))} required />
          <input style={inputStyle} type="number" placeholder="Price" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} required />
          <button style={btnStyle} type="submit" disabled={mutation.isPending}>
            {mutation.isPending ? 'Saving...' : 'Add Trade'}
          </button>
        </form>
      </div>

      <div style={card}>
        <h2 style={{ marginBottom: 16, fontSize: 16, color: '#94a3b8' }}>Trade History</h2>
        {trades.length === 0 ? (
          <p style={{ color: '#64748b' }}>No trades yet.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #334155', color: '#64748b', textAlign: 'left' }}>
                <th style={{ padding: '8px 0' }}>Symbol</th>
                <th>Type</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Total</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {trades.map(t => (
                <tr key={t.id} style={{ borderBottom: '1px solid #1e293b' }}>
                  <td style={{ padding: '10px 0', fontWeight: 600 }}>{t.symbol}</td>
                  <td style={{ color: t.type === 'buy' ? '#34d399' : '#f87171' }}>{t.type.toUpperCase()}</td>
                  <td>{t.quantity}</td>
                  <td>${Number(t.price).toLocaleString()}</td>
                  <td>${Number(t.total).toLocaleString()}</td>
                  <td style={{ color: '#64748b' }}>{new Date(t.created_at).toLocaleDateString('pt-BR')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
